export enum AuthState {
  Loading,
  Error,
  SignIn,
  SignedIn,
  Challenge,
  VerifyEmail,
}
